<span class="my-auto" [ngClass]="classes">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="none">
        <path
            d="M22.3055 10.5415H21.5V10.5H12.5V14.5H18.1515C17.327 16.8285 15.1115 18.5 12.5 18.5C9.1865 18.5 6.5 15.8135 6.5 12.5C6.5 9.1865 9.1865 6.5 12.5 6.5C14.0295 6.5 15.421 7.077 16.4805 8.0195L19.309 5.191C17.523 3.5265 15.134 2.5 12.5 2.5C6.9775 2.5 2.5 6.9775 2.5 12.5C2.5 18.0225 6.9775 22.5 12.5 22.5C18.0225 22.5 22.5 18.0225 22.5 12.5C22.5 11.8295 22.431 11.175 22.3055 10.5415Z"
            fill="#FDD015" />
        <path
            d="M3.65295 7.8455L6.93845 10.255C7.82745 8.054 9.98045 6.5 12.5 6.5C14.0295 6.5 15.421 7.077 16.4805 8.0195L19.309 5.191C17.523 3.5265 15.134 2.5 12.5 2.5C8.65895 2.5 5.32795 4.6685 3.65295 7.8455Z"
            fill="#FF3D00" />
        <path
            d="M12.5 22.5003C15.083 22.5003 17.43 21.5118 19.2045 19.9043L16.1095 17.2853C15.0718 18.0745 13.8038 18.5014 12.5 18.5003C9.89903 18.5003 7.69053 16.8418 6.85853 14.5273L3.59753 17.0398C5.25253 20.2783 8.61353 22.5003 12.5 22.5003Z"
            fill="#4CAF50" />
        <path
            d="M22.3055 10.5415H21.5V10.5H12.5V14.5H18.1515C17.7571 15.6082 17.0467 16.5766 16.108 17.2855L16.1095 17.2845L19.2045 19.9035C18.9855 20.1025 22.5 17.5 22.5 12.5C22.5 11.8295 22.431 11.175 22.3055 10.5415Z"
            fill="#1976D2" />
    </svg>
</span>
